import { render, staticRenderFns } from "./NonGeoPicklDetails.vue?vue&type=template&id=fa8d3538&"
import script from "./NonGeoPicklDetails.vue?vue&type=script&lang=ts&"
export * from "./NonGeoPicklDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa8d3538')) {
      api.createRecord('fa8d3538', component.options)
    } else {
      api.reload('fa8d3538', component.options)
    }
    module.hot.accept("./NonGeoPicklDetails.vue?vue&type=template&id=fa8d3538&", function () {
      api.rerender('fa8d3538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/NonGeoPicklDetails.vue"
export default component.exports